export function userActivation(
	callback: Function,
	autoStartTimeOut = 0,
	force = false
): Promise< HTMLScriptElement > {
	return new Promise( async ( resolve, reject ) => {
		if ( force ) {
			try {
				resolve( await callback() );
			} catch ( e ) {
				reject( e );
			}
			return;
		}

		let autoStartTimeOutId: number | null = null;
		let init = false;

		if ( /complete|interactive|loaded/.test( document.readyState ) ) {
			run();
		} else {
			document.addEventListener( 'DOMContentLoaded', run, false );
		}

		function run() {
			if ( autoStartTimeOut ) {
				autoStartTimeOutId = window.setTimeout(
					runCallback,
					autoStartTimeOut
				);
			}

			if ( 0 === autoStartTimeOut || autoStartTimeOut > 500 ) {
				setTimeout( () => {
					document.addEventListener( 'scroll', runCallback );
					document.addEventListener( 'mousemove', runCallback );
					document.addEventListener( 'mousedown', runCallback );
					document.addEventListener( 'keydown', runCallback );
				}, 500 );
			}
		}

		async function runCallback() {
			if ( autoStartTimeOutId ) {
				clearTimeout( autoStartTimeOutId );
			}

			if ( init ) {
				return;
			}

			init = true;

			document.removeEventListener( 'scroll', runCallback );
			document.removeEventListener( 'mousemove', runCallback );
			document.removeEventListener( 'mousedown', runCallback );
			document.removeEventListener( 'keydown', runCallback );

			try {
				resolve( await callback() );
			} catch ( e ) {
				reject( e );
			}
		}
	} );
}
